import React from 'react';
import { login } from 'account-portal-library/lib/appleSignIn';
import AppVars from '../../../../AppVars.js';
import Loader from '../../../Loader';
import pushAnalytics from '../../../../analytics/pushAnalytics.js';

const appVars = AppVars.getInstance();

class AppleButton extends React.Component {
    constructor(props) {
        super(props);
        this.handleAppleLogin = this.handleAppleLogin.bind(this);
        this.state = { ...props }
    }

    async handleAppleLogin() {
        window._dL = { ...(window._dL || {}), user_login_source: "Apple" };

        pushAnalytics('aa-link', {
            ctaText: 'Continue with Apple',
            link_text: 'Continue With Apple',
            link_type: 'button',
            link_trigger: 'aa-link',
            content_section: 'Sign in Landing Page',
            metrics: 'km-sign-in-start',
            user_login_source: 'Apple',
            user_entry_source: "Toyota",
        }, { component_name: "AppleButton", component_version: "1.0.0" });

        await login(
            sessionStorage.AP_STYLE,
            appVars.getBaseUrl(),
            appVars.getRealm(),
            appVars.getAppleSignInTree(),
            appVars.getDomain(),
            appVars.getName()
        )
    }

    render() {
        if (this.props.implicitRegister) {
            pushAnalytics("aa-component-view", { component_name: "AppleButton", component_version: "1.0.0" });
            this.handleAppleLogin();
            return (
                <Loader />
            )
        } else {
            return (
                <button alt="Continue With Apple" onClick={this.handleAppleLogin} className="button-box-apple">
                    <span className="button-text button-text-apple">Continue with Apple</span>
                </button>
                // <img alt="Sign In with Apple" onClick={this.handleAppleLogin} src={AppleButtonImg} className="button-apple button-social"/>
            )
        }
    }
}

export default AppleButton;